import { render, staticRenderFns } from "./DesafiosEquipeTarefasView.vue?vue&type=template&id=3c10cc71&scoped=true&"
import script from "./DesafiosEquipeTarefasView.vue?vue&type=script&lang=js&"
export * from "./DesafiosEquipeTarefasView.vue?vue&type=script&lang=js&"
import style0 from "./DesafiosEquipeTarefasView.vue?vue&type=style&index=0&id=3c10cc71&lang=scss&scoped=true&"
import style1 from "./DesafiosEquipeTarefasView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c10cc71",
  null
  
)

export default component.exports